<template>
  <div class="container sv sv042">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>教えて！みんなのローン活用術</HeadingOne>

    <p class="_mb-md-60">
      こんなときにあなたをサポート！au PAY
      スマートローンのいろいろな使い方をご紹介します。
    </p>

    <section id="section_01">
      <CardGroups class="-image-top-list">
        <CardBox router-name="sv053" class="-image-top">
          <CardHeader>
            <CardImage class="-blue"
              ><img
                src="@/assets/images/sv/sv053/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">“ちょっとだけ”がすごく助かる生活の工夫</h3>
          </CardHeader>
          <CardBody
            >ローンの借り入れ理由として多いのが、実は「日々の生活費」なんです！</CardBody
          >
        </CardBox>
        <CardBox router-name="sv008" class="-image-top">
          <CardHeader>
            <CardImage class="-blue"
              ><img
                src="@/assets/images/sv/sv008/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">急な飲み会･･･給料日前だけど参加したい！</h3>
          </CardHeader>
          <CardBody
            >お誘いが多いのはうれしいけど、飲み会の回数が重なると結構な出費に…。</CardBody
          >
        </CardBox>
        <CardBox router-name="sv006" class="-image-top">
          <CardHeader>
            <CardImage class="-blue"
              ><img
                src="@/assets/images/sv/sv006/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">結婚や出産…お祝いは突然やってくる?！</h3>
          </CardHeader>
          <CardBody
            >「お祝い」続きで資金不足に…せっかくのお祝いを諦める？</CardBody
          >
        </CardBox>
        <CardBox router-name="sv007" class="-image-top">
          <CardHeader>
            <CardImage class="-blue"
              ><img
                src="@/assets/images/sv/sv007/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">せっかくの卒業旅行…お金のことで諦めないで！</h3>
          </CardHeader>
          <CardBody
            >楽しいはずの旅行…お金の都合で妥協したり、諦めかけたことってありませんか？</CardBody
          >
        </CardBox>
      </CardGroups>

      <BtngroupSingle class="-margin-lg _mt-0">
        <BtnMain class="-normal -lg" router-name="sv003"
          >知っておきたい！ローンについてへ戻る</BtnMain
        >
      </BtngroupSingle>

      <CvBox class="_mb-120 _mb-sm-60" />
    </section>
  </div>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import HeadingOne from "@/components/heading/HeadingOne";
import CardGroups from "@/components/card/CardGroups";
import CardBox from "@/components/card/CardBox";
import CardHeader from "@/components/card/CardHeader";
import CardImage from "@/components/card/CardImage";
import CardBody from "@/components/card/CardBody";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import CvBox from "@/components/box/CvBox";
export default {
  name: "Sv042",
  components: {
    BreadcrumbGroup,
    HeadingOne,
    CardGroups,
    CardBox,
    CardHeader,
    CardImage,
    CardBody,
    BtngroupSingle,
    BtnMain,
    CvBox,
  },
  setup() {
    setMeta({
      title: "教えて！みんなのローン活用術｜知っておきたい！ローンについて",
      description:
        "こんなときにあなたをサポート！ローンのいろいろな使い方やみんなのローンの活用術をご紹介します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,おトク,ローン活用",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "知っておきたい！ローンについて",
          routerName: "sv003",
        },
        {
          text: "教えて！みんなのローン活用術",
          active: true,
        },
      ],
    };
  },
};
</script>
